import * as React from "react";
export var DrawerContext = React.createContext(null);
export var LoadingContext = React.createContext(null);
export var ModalContext = React.createContext({
    toggleModal: function () { },
});
export var UserContext = React.createContext(null);
export var QueryContext = React.createContext(null);
